import { useCurrentUser } from "../../auth/useCurrentUser";

// Who may change a control on a standard page. The API is the control (controls:write on
// /controls/soa, Cyber Essentials included, and /legal/soa; documents:write on /documents); this only decides
// whether Edit and the evidence buttons are offered. Call once per page, never per row:
// useCurrentUser fetches /auth/me.

export function useStandardPermissions(): { canAssess: boolean; canAttach: boolean } {
  const { user } = useCurrentUser();
  const permissions = user?.permissions ?? [];
  return {
    canAssess: permissions.includes("controls:write"),
    canAttach: permissions.includes("documents:write"),
  };
}
